export const faq = {
  badge: "FAQ",
  title: "Preguntas frecuentes",
  subtitle: "Todo lo que necesitas saber sobre DONKEY TRAVEL",
  items: {
    q1: {
      question: "¿Cómo funciona el sistema de Noches?",
      answer:
        "Es un intercambio directo entre dos propietarios. Acordáis las fechas (simultáneas o diferidas) y las modalidades. Sin puntos, sin cálculos complicados, solo trato humano.",
    },
    q2: {
      question: "¿Debo intercambiar al mismo tiempo?",
      answer:
        "¡No! Esa es la ventaja de nuestro sistema flexible. Puedes recibir a Jean en abril e ir a su casa en octubre. ¡Esto también permite conocerse durante la entrega de llaves!",
    },
    q3: {
      question: "¿Cómo se verifican los miembros?",
      answer:
        "Todos los miembros deben ser propietarios verificados de Airbnb. También verificamos la identidad, el alojamiento y las reseñas de Airbnb de cada miembro para garantizar la seguridad de la comunidad.",
    },
    q4: {
      question: "¿Qué pasa si hay un problema?",
      answer:
        "Nuestro equipo de soporte está disponible 7/7 para acompañarte. Además, nuestro sistema de reseñas y puntuación permite mantener una comunidad de confianza y resolver rápidamente cualquier problema.",
    },
    q5: {
      question: "¿Hay gastos ocultos?",
      answer:
        "No, ningún gasto oculto. Solo pagas tu suscripción anual según la zona geográfica elegida. Los intercambios son luego totalmente gratuitos, sin comisión ni gastos adicionales.",
    },
    q6: {
      question: "¿Puedo elegir quién se aloja en mi casa?",
      answer:
        "¡Absolutamente! Tienes el control total. Puedes consultar los perfiles, leer las reseñas y aceptar o rechazar cada solicitud de intercambio según tus preferencias.",
    },
    q7: {
      question: "¿Mi alojamiento está asegurado durante los intercambios?",
      answer:
        "Sí, todos los intercambios están cubiertos por nuestro seguro asociado. Además, recomendamos verificar tu seguro de hogar para una protección óptima.",
    },
    q8: {
      question: "¿Con cuánta antelación debo reservar?",
      answer:
        "Depende de cada propietario. Algunos aceptan reservas de última hora, otros prefieren planificar con varios meses de antelación. Recomendamos reservar al menos con 2-3 semanas de antelación.",
    },
  },
  cta: {
    title: "¿Tienes otras preguntas?",
    subtitle:
      "Nuestro equipo está aquí para ayudarte a comenzar tu aventura DONKEY TRAVEL",
    button: "Contáctanos",
  },
};
